var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetirement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 43,
    viewBox: "0 0 56 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 41,
    width: 41,
    height: 2,
    fill: "#767676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0341 24.6845C26.4083 17.5321 20.1029 12.2412 12.9505 12.867C5.79815 13.4927 0.507272 19.7981 1.13302 26.9505L2.12922 26.8634L3.12541 26.7762L7.11019 26.4276L9.10258 26.2533L13.0874 25.9047L14.4678 41.683L16.4602 41.5087L15.0797 25.7304L19.0645 25.3817L21.0569 25.2074L25.0417 24.8588L26.0379 24.7716L27.0341 24.6845ZM20.8006 23.2222L24.6867 22.8822C23.7073 19.3285 21.0112 16.5493 17.6136 15.3964C19.0902 17.2596 20.2495 20.0158 20.8006 23.2222ZM8.79755 16.1677C5.65174 17.8931 3.47923 21.0982 3.13179 24.768L7.0179 24.428C7.00387 21.1746 7.66694 18.259 8.79755 16.1677ZM18.7906 23.3981C17.9313 18.8913 15.6218 15.6447 13.212 15.8556C10.8022 16.0664 9.09159 19.6647 9.02791 24.2522L18.7906 23.3981Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 20C46.866 20 50 16.866 50 13C50 9.13401 46.866 6 43 6C39.134 6 36 9.13401 36 13C36 16.866 39.134 20 43 20ZM43 18C45.7614 18 48 15.7614 48 13C48 10.2386 45.7614 8 43 8C40.2386 8 38 10.2386 38 13C38 15.7614 40.2386 18 43 18Z",
    fill: "#767676"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 12,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#767676"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#767676"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 44 22)",
    fill: "#767676"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 44 0)",
    fill: "#767676"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.071,
    y: 18.6567,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(45 50.071 18.6567)",
    fill: "#767676"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5147,
    y: 3.10059,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(45 34.5147 3.10059)",
    fill: "#767676"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3431,
    y: 20.071,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(135 37.3431 20.071)",
    fill: "#767676"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8995,
    y: 4.51465,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(135 52.8995 4.51465)",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirement);
export default __webpack_public_path__ + "static/media/retirement.fa99c85991e1ef3ae568109368297971.svg";
export { ForwardRef as ReactComponent };